import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { Profile } from './Profile';

const meta: Meta<typeof Profile> = {
  title: 'features/Profile',
  component: Profile,
  args: {
    onSuccessSubmitCallback: action('clicked'),
  },
};

export default meta;

type Story = StoryObj<typeof Profile>;

export const Basic: Story = {
  render: args => <Profile {...args} />,
};
